module.exports = __webpack_public_path__ + "static/media/map-filled.a2970852.svg";